export const LANDING_PAGE_PATH = "/";
export const LEGACY_LANDING_PAGE_PATH = "/main";

export const COLLECTIONS_PATH = "/collections";
export const CART_PATH = "/cart";
export const PROFILE_PATH = "/profile";

export const BRANDS_PATH = "/brands";
export const BRAND_EXPLORER_PATH = "/brand-explorer";
export const BRAND_EXPLORER_RESULTS_PATH = `${BRAND_EXPLORER_PATH}/results`;

const RESULTS_PATH = "/results";
export const RESULTS_PATH_PREFIX = `${RESULTS_PATH}/`;

export const MCP_PATH_PREFIX = "/mcp";
// OAuth consent page for the Cosimo MCP server (docs/shop-agent/cosimo-mcp-oauth.md).
export const MCP_AUTHORIZE_PATH = `${MCP_PATH_PREFIX}/authorize`;

export const LEGAL_PATH_PREFIX = "/legal";
export const LEGAL_PRIVACY_POLICY_PATH = `${LEGAL_PATH_PREFIX}/privacy-policy`;
export const LEGAL_TERMS_OF_SERVICE_PATH = `${LEGAL_PATH_PREFIX}/terms-of-service`;
export const LEGAL_ACCESSIBILITY_PATH = `${LEGAL_PATH_PREFIX}/accessibility`;

export function buildLegalPath(pageKey: string): string {
  return `${LEGAL_PATH_PREFIX}/${pageKey}`;
}

export function isSafeReturnTo(value: string | null): value is string {
  return !!value && value.startsWith("/") && !value.startsWith("//") && !value.startsWith("/\\");
}

export function appendReturnTo(path: string, returnTo: string | null): string {
  return isSafeReturnTo(returnTo) ? `${path}?returnTo=${encodeURIComponent(returnTo)}` : path;
}

export function getResultsThreadIdFromPath(pathname: string): string | null {
  if (!pathname.startsWith(RESULTS_PATH_PREFIX)) {
    return null;
  }

  return pathname.slice(RESULTS_PATH_PREFIX.length).split(/[/?]/)[0] || null;
}
